import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { Button } from '@lanl-web/lanl-components';

import './CallToAction.scss';

export const CallToAction = ({ btnLabel, btnLink, className, text }) => {
  const classes = classNames('call-to-action', className);

  return (
    <div className={classes}>
      <div className='content'>
        <h3 className='title'>{text}</h3>
        <Button className='cta-btn' href={btnLink} outline color='white'>
          {btnLabel}
        </Button>
      </div>
    </div>
  );
};

CallToAction.defaultProps = {};

CallToAction.propTypes = {
  btnLabel: PropTypes.string.isRequired,
  btnLink: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default CallToAction;

export const fragBoxCallToAction = graphql`
  fragment boxCTA on DirectusData_rl_components {
    call_to_actions {
      cta {
        title
        button_text
        url {
          page {
            slug
            parent {
              slug
              parent {
                slug
                parent {
                  slug
                }
              }
            }
          }
          project {
            slug
          }
        }
      }
    }
  }
`;
